export const spacing = {
  xs: '4px',
  s: '8px',
  m: '12px',
  l: '16px',
  lg: '1.25rem',
  xl: '1.5rem',
  xxl: '1.75rem',
  xxxl: '2rem',
  xxxxl: '2.25rem',
  xxxxxl: '2.5rem',
  xxxxxxl: '2.75rem'
};
